export default [
  {
    path: '/rolemanagement',
    name: 'rolemanagement',
    component: () => import('@/views/system/RoleManagement.vue'),
    meta: {},
  },
];
